import { BadgeCheck, ImagePlus } from "lucide-react";

export function ProofAreas({ content, images = [] }) {
  return (
    <>
      <section id="projects" className="section proof-section" data-testid="proof-section">
        <div className="section-heading wide">
          <p className="overline" data-testid="proof-overline">{content.overline}</p>
          <h2 data-testid="proof-title">{content.title}</h2>
          <p data-testid="proof-description">{content.description}</p>
        </div>

        {content.stats && (
          <div className="proof-stat-strip" data-testid="proof-stat-strip">
            {content.stats.map((stat, index) => (
              <div className="proof-stat" key={stat.value} data-testid={`proof-stat-${index + 1}`}>
                <strong data-testid={`proof-stat-value-${index + 1}`}>{stat.value}</strong>
                <span data-testid={`proof-stat-label-${index + 1}`}>{stat.label}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="section proof-evidence-section" data-testid="proof-evidence-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="proof-evidence-overline">{content.overline}</p>
          <h2 data-testid="proof-evidence-title">{content.cards?.[0]?.category || content.title}</h2>
        </div>
        <div className="proof-grid" data-testid="proof-card-grid">
        {content.cards.map((card, index) => (
          <article className={`proof-card ${card.featured ? "featured-proof" : ""}`} key={card.title} data-testid={`proof-card-${index + 1}`}>
            <div className="proof-image-slot" data-testid={`proof-image-slot-${index + 1}`}>
              {images[index]?.image ? (
                <img src={images[index].image} alt={card.title} data-testid={`proof-image-${index + 1}`} />
              ) : (
                <>
                  <ImagePlus size={28} aria-hidden="true" />
                  <span>{card.category}</span>
                </>
              )}
            </div>
            <div className="proof-body">
              <p className="card-eyebrow" data-testid={`proof-card-category-${index + 1}`}>{card.category}</p>
              <h3 data-testid={`proof-card-title-${index + 1}`}>{card.title}</h3>
              <ul data-testid={`proof-card-scope-${index + 1}`}>
                {card.scope.map((scope) => (
                  <li key={scope} data-testid={`proof-card-scope-item-${index + 1}-${scope.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>
                    <BadgeCheck size={14} aria-hidden="true" /> {scope}
                  </li>
                ))}
              </ul>
              <p className="proof-outcome" data-testid={`proof-card-outcome-${index + 1}`}>{card.outcome}</p>
            </div>
          </article>
        ))}
        </div>
      </section>
    </>
  );
}